/**
 * Translation system for tracking history block
 * Supports simple key-based translations with variable interpolation (e.g., {{carrier}})
 */

import { bg } from "./bg";
import { cs } from "./cs";
import { da } from "./da";
import { de } from "./de";
import { en } from "./en";
import { es } from "./es";
import { fi } from "./fi";
import { fr } from "./fr";
import { hu } from "./hu";
import { it } from "./it";
import { nl } from "./nl";
import { no } from "./no";
import { pl } from "./pl";
import { pt } from "./pt";
import { sk } from "./sk";
import { sv } from "./sv";
import { zh } from "./zh";
import { ja } from "./ja";

const translations = {
  bg,
  cs,
  da,
  de,
  en,
  es,
  fi,
  fr,
  hu,
  it,
  nl,
  no,
  pl,
  pt,
  sk,
  sv,
  zh,
  ja,
} as const;

type TranslationKey = string;
type Variables = Record<string, string | number>;

export function tLayout(
  locale: string,
  defaultLocale: string,
): (key: TranslationKey, vars?: Variables) => string {
  return (key: TranslationKey, vars?: Variables): string => {
    const localeToUse = (
      locale in translations ? locale : defaultLocale
    ) as keyof typeof translations;
    const dict = translations[localeToUse] || translations.en;

    const keys = key.split(".");
    let value: unknown = dict;

    for (const k of keys) {
      if (value && typeof value === "object" && k in (value as object)) {
        value = (value as Record<string, unknown>)[k];
      } else {
        return key;
      }
    }

    if (typeof value !== "string") {
      return key;
    }

    if (!vars) {
      return value;
    }

    return value.replace(/\{\{(\w+)\}\}/g, (_, varName) => {
      return varName in vars ? String(vars[varName]) : `{{${varName}}}`;
    });
  };
}
